import React from 'react'

const Hidden = ({ name }) => <input type="hidden" name={name} />

export default Hidden
